import { useField } from "formik"
import { ChangeEventHandler, ReactElement } from "react"
import styles from "@/styles/Forms.module.scss"
import { Checkbox } from "@mui/material"
import classNames from "classnames"

interface Option {
  value: any
  component: ReactElement
}

interface Props {
  id?: string
  label?: string
  notes?: string
  error?: string
  hideError?: boolean
  required?: boolean
  type?: string
  autoComplete?: string
  disabled?: boolean
  name?: string
  onChange?: ChangeEventHandler<HTMLInputElement>
  style?: object
  className?: string
  options: Option[]
  checked?: boolean
}

export default function CheckboxField({
  label,
  className,
  options,
  style,
  name,
  ...rest
}: Props) {
  const [field, meta, helpers] = name ? useField(name) : []

  return (
    <div
      className={classNames(styles.checkboxWrapper, className)}
      style={style}
    >
      {label && <p>{label}</p>}
      {options.map((item, i) => (
        <div key={i} className="d-flex">
          <label>
            <Checkbox
              sx={{
                width: "1rem",
                padding: 0,
                color: "#bcbcbc",
                "&.Mui-checked": {
                  color: "#000000",
                },
              }}
              {...field}
              {...rest}
            />
            {item.component}
          </label>
        </div>
      ))}
    </div>
  )
}
